<script setup>
import { usePage } from '@inertiajs/vue3'

const isTenantActive = (tenant) => window.location.origin === tenant.domain
const isTenantNoFollow = (tenant) => route('index') !== route().current() && !isTenantActive(tenant)

const switchTenantUrl = (tenant) => {
  return usePage().props.auth && !isTenantActive(tenant)
    ? route('auth.tenants.switch', tenant)
    : usePage().props.session.language === 'en'
      ? tenant.domain
      : tenant.domain + '/' + usePage().props.session.language
}
</script>

<template>
  <a
    v-for="tenant in $page.props.header.tenants_in_groups"
    :key="tenant.id"
    :href="switchTenantUrl(tenant)"
    :rel="isTenantNoFollow(tenant) ? 'nofollow' : ''"
    class="flex items-center px-3 hover:underline"
    :class="isTenantActive(tenant) ? 'bg-zinc-100' : 'text-black'"
  >
    <img
      class="size-4 flex mr-1"
      :src="tenantAsset('theme/images/icons/32x32.png', tenant)"
      :alt="tenant.site_short_name"
    >
    {{ tenant.site_short_name }}
  </a>
</template>
